import { render, staticRenderFns } from "./InsScheme.vue?vue&type=template&id=74ecc6a1&scoped=true"
import script from "./InsScheme.vue?vue&type=script&lang=js"
export * from "./InsScheme.vue?vue&type=script&lang=js"
import style0 from "./InsScheme.vue?vue&type=style&index=0&id=74ecc6a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecc6a1",
  null
  
)

export default component.exports